import { CopyIcon } from '@chakra-ui/icons';
import { Box, Card, IconButton, Image, Text, VStack } from '@chakra-ui/react';
import { BarcodeWithErrorBoundary } from 'components/modules/Barcode';
import { copyToClipboard } from 'libs/clipboard';
import { FC } from 'react';
import Clock from 'react-live-clock';

type CuminBarcodeBoxProps = {
  cardNumber: string;
  imageUrl?: string | null;
  barcodeFormat?: string;
};

const CuminBarcodeBox: FC<CuminBarcodeBoxProps> = ({
  cardNumber,
  imageUrl,
  barcodeFormat
}) => {
  const handleCopyCardNumber = () => {
    copyToClipboard({
      targetText: cardNumber,
      successMessage: '会員番号をコピーしました',
      errorMessage: '会員番号のコピーに失敗しました'
    });
  };

  if (!imageUrl) {
    return null;
  }
  return (
    // カードの上半分を管理画面側で設定し、下半分をバーコード表示する
    <VStack spacing={0} m="0">
      <Image
        alt="カード画像"
        src={imageUrl}
        w="100%"
        objectFit="contain"
        borderTopRadius="10px"
      />
      {cardNumber && (
        <Box position="relative" w="100%">
          <Card
            pt="0.5rem"
            w="100%"
            borderTopRadius="0"
            borderBottomRadius="10px"
            boxShadow="none"
            onClick={handleCopyCardNumber}
          >
            <VStack spacing="0">
              {/** スクリーンショット防止用にリアルタイムで時刻を表示 */}
              <Text fontSize="2xs">
                <Clock
                  format={'YYYY/MM/DD HH:mm:ss'}
                  timezone={'Asia/Tokyo'}
                  ticking
                />
              </Text>
              <BarcodeWithErrorBoundary
                code={cardNumber}
                format={barcodeFormat}
                height={30}
                fontSize={16}
                flat
                textMargin={10}
              />
            </VStack>
          </Card>
          <IconButton
            aria-label="カード番号をコピー"
            icon={<CopyIcon boxSize={5} />}
            position="absolute"
            bottom="0.3rem"
            right="0.3rem"
            size="xs"
            variant="ghost"
            onClick={handleCopyCardNumber}
            zIndex={1}
            _active={{ bg: 'transparent' }}
            _focus={{ bg: 'transparent' }}
          />
        </Box>
      )}
    </VStack>
  );
};
export default CuminBarcodeBox;
